<template>
  <div
    class="IconButton btn"
    :class="{ disabled }"
    :aria-disabled="disabled ? 'true' : null"
    @click="!disabled && $emit('click')">
    <div class="label">
      <slot />
    </div>
    <div class="icon">
      <Icon :name="icon" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: "send",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.IconButton {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .label {
    padding-right: 1em;
  }

  &.disabled {
    opacity: 0.25;
    cursor: not-allowed;
  }
}
</style>
